import { Component, Input } from '@angular/core';
import { SignDetail } from 'src/app/model/sign/sign-detail';

@Component({
  selector: 'sign-associations-overview',
  templateUrl: './sign-associations-overview.component.html',
  styleUrls: ['./sign-associations-overview.component.scss']
})
export class SignAssociationsOverviewComponent {
  @Input()
  sign: SignDetail;
}
